/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDevicePinAccess200Response
 */
export interface GetDevicePinAccess200Response {
    /**
     * 
     * @type {string}
     * @memberof GetDevicePinAccess200Response
     */
    pin: string;
    /**
     * 
     * @type {Date}
     * @memberof GetDevicePinAccess200Response
     */
    expirationTime: Date;
    /**
     * 
     * @type {number}
     * @memberof GetDevicePinAccess200Response
     */
    marginTimeSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof GetDevicePinAccess200Response
     */
    lifeTimeSeconds: number;
}

/**
 * Check if a given object implements the GetDevicePinAccess200Response interface.
 */
export function instanceOfGetDevicePinAccess200Response(value: object): value is GetDevicePinAccess200Response {
    if (!('pin' in value) || value['pin'] === undefined) return false;
    if (!('expirationTime' in value) || value['expirationTime'] === undefined) return false;
    if (!('marginTimeSeconds' in value) || value['marginTimeSeconds'] === undefined) return false;
    if (!('lifeTimeSeconds' in value) || value['lifeTimeSeconds'] === undefined) return false;
    return true;
}

export function GetDevicePinAccess200ResponseFromJSON(json: any): GetDevicePinAccess200Response {
    return GetDevicePinAccess200ResponseFromJSONTyped(json, false);
}

export function GetDevicePinAccess200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDevicePinAccess200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'pin': json['pin'],
        'expirationTime': (new Date(json['expirationTime'])),
        'marginTimeSeconds': json['marginTimeSeconds'],
        'lifeTimeSeconds': json['lifeTimeSeconds'],
    };
}

export function GetDevicePinAccess200ResponseToJSON(json: any): GetDevicePinAccess200Response {
    return GetDevicePinAccess200ResponseToJSONTyped(json, false);
}

export function GetDevicePinAccess200ResponseToJSONTyped(value?: GetDevicePinAccess200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pin': value['pin'],
        'expirationTime': ((value['expirationTime']).toISOString()),
        'marginTimeSeconds': value['marginTimeSeconds'],
        'lifeTimeSeconds': value['lifeTimeSeconds'],
    };
}

